/**
 * When a `spin_boundary_start` should run the pre-spin drop-out. In normal play the player's spin
 * request already drops the base grid (`preSpin`), so only feature spins drop here; in replay there
 * is no spin request, so the base spin's boundary must drop too.
 */
export class PreSpinDropOutPolicy {
  /**
   * @param dropOnBaseSpinBoundary When true, a BASE-mode `spin_boundary_start` also triggers the
   *   drop-out. Set it in REPLAY mode: a replay plays a recorded round directly, with no spin
   *   request → `preSpin` to clear the boot fallback grid; without it the first reveal draws on top
   *   of the un-recycled boot grid (and the strict consistency check then reads stale boot symbols).
   *   In NORMAL play leave it false — `preSpin` owns the base-mode drop, so dropping here would
   *   double-drop.
   */
  public constructor(private readonly dropOnBaseSpinBoundary: boolean = false) {}

  public shouldRunOnSpinBoundaryStart(input: { spinModeIdentifier?: string }): boolean {
    // Undefined mode = the event carries no `spin_boundary_start` action (a cascade collapse event).
    // Those must NEVER drop — dropping mid-cascade would destroy the chain.
    if (input.spinModeIdentifier === undefined) return false;
    const mode = input.spinModeIdentifier.toLowerCase();
    if (mode === "base") return this.dropOnBaseSpinBoundary;
    // Feature modes (free_spins, bonus, …): run at boundary start.
    return true;
  }
}
